import React, { FC, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "../../select";
import Typography from "../../typography";
import Button from "../../button";
import { HeadLine3 } from "../../typography/styled";
import { icons } from "../../../icons";
import {
  Container,
  HeadWrapper,
  IconButton,
  BodyModal,
  ActionsWrapper,
  CurrentConfiguration,
  ErrorText,
} from "./styles";

type ChangeConfigurationProps = {
  closeModalCancel: () => void;
  closeModal: (data: any) => void;
  alertTitle: string;
  dataToEdit: {
    currentConfiguration?: string;
    options: { value: string | number; label: string }[];
  };
  loading?: boolean;
  loadingComplete?: boolean;
};

const ChangeClientConfiguration: FC<ChangeConfigurationProps> = ({
  closeModal,
  closeModalCancel,
  alertTitle,
  dataToEdit,
  loading,
  loadingComplete,
}) => {
  const [t] = useTranslation();
  const [selectedValue, setSelectedValue] = useState<any>(null);
  const [touched, setTouched] = useState<boolean>(false);

  const error = useMemo(() => {
    if (!touched) return "";
    if (!selectedValue) {
      return t("REQUIRED_FIELD");
    }
    return "";
  }, [selectedValue, touched, t]);

  const handleSubmit = () => {
    setTouched(true);
    if (error) return;
    closeModal({
      configuration: selectedValue,
    });
  };

  return (
    <Container>
      <HeadWrapper>
        <HeadLine3>{alertTitle}</HeadLine3>
        <IconButton onClick={closeModalCancel}>
          <img src={icons.CloseIcon} alt="close" />
        </IconButton>
      </HeadWrapper>
      <BodyModal>
        <CurrentConfiguration>
          <Typography variant="body">
            {t("CURRENT_CONFIGURATION_LABEL")}
          </Typography>
          <Typography variant="h3">
            {dataToEdit?.currentConfiguration || t("NOT_AVAILABLE")}
          </Typography>
        </CurrentConfiguration>
        <Select
          data={dataToEdit?.options || []}
          selectedValue={selectedValue}
          onChange={(option) => setSelectedValue(option?.value ?? option)}
          title={t("NEW_CONFIGURATION")}
          required
          customStyles={{ width: "100%" }}
        />
        {error ? <ErrorText>{error}</ErrorText> : null}
        <ActionsWrapper>
          <Button
            variant="stroke"
            size="display"
            customStyles={{ flex: 1, justifyContent: "center" }}
            onClick={closeModalCancel}
            title={t("CANCEL")}
          />
          <Button
            variant="primary"
            size="display"
            loading={loading}
            loadingComplete={loadingComplete}
            customStyles={{ flex: 1, justifyContent: "center" }}
            onClick={handleSubmit}
            title={t("CHANGE_CONFIGURATION_ACTION")}
          />
        </ActionsWrapper>
      </BodyModal>
    </Container>
  );
};

export default ChangeClientConfiguration;
